/** Lightweight click + pageview tracker. Uses beacon/fire-and-forget. */
import { api } from "@/lib/api";

export function trackClick(buttonId, metadata = {}) {
  if (!buttonId) return;
  try {
    api.post("/track/click", {
      button_id: String(buttonId).slice(0, 120),
      page: window.location.pathname,
      metadata,
    }).catch(() => {});
  } catch (_) {}
}

export function trackPageview(path, referrer = "") {
  try {
    api.post("/track/pageview", {
      path: path || window.location.pathname,
      referrer: referrer || document.referrer || "",
    }).catch(() => {});
  } catch (_) {}
}

/** Installs a global click listener that auto-fires for [data-testid] elements. */
export function installGlobalClickTracker() {
  document.addEventListener("click", (e) => {
    const el = e.target.closest("[data-testid]");
    if (!el) return;
    const testid = (el.getAttribute("data-testid") || "").split(" ")[0];
    if (!testid) return;
    trackClick(testid, { tag: el.tagName });
  }, { capture: true });
}
